import { Box } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { ReactNode } from "react";
import { useStyles } from "./Controller.style";
import Text from "$components/Text";

export interface IFormController {
  label?: string;
  name: string;
  required?: boolean;
  rules?: any;
  style?: any;
  children: (...args: any) => ReactNode;
}

export const FormController = ({
  label,
  name,
  rules,
  children,
  style,
  required = false,
}: IFormController) => {
  const classes = useStyles();
  const {
    control,
    formState: { errors },
  } = useFormContext();

  if (!control) {
    throw new Error("you need a FormProvider");
  }

  const crules = rules ? { ...rules } : {};

  if (required && !crules.required) {
    crules.required = "Veuillez remplir ce champ";
  }
  const labelText = required && label ? `${label} *` : label;
  const error = errors?.[name];

  return (
    <Controller
      control={control}
      name={name}
      rules={crules}
      render={({ field }) => (
        <Box style={{ flex: 1, ...style }} className={classes.wrapper}>
          {children({ ...field, label: labelText })}
          {error?.message && (
            <Text className={classes.errorField} data-testid="errorInput">
              {error.message.toString()}
            </Text>
          )}
        </Box>
      )}
    />
  );
};
